var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeInMediaQuery = exports.getResponsiveProp = void 0;
const facepaint_1 = __importDefault(require("facepaint"));
exports.getResponsiveProp = ({ theme, propName, propValue, }) => {
    const breakPointList = theme.breakpoints;
    const mediaQuery = facepaint_1.default(breakPointList.map((breakPoint) => `@media (min-width: ${breakPoint})`));
    return mediaQuery({ [propName]: propValue })[0];
};
exports.mergeInMediaQuery = ({ result, propWithMediaQueries, }) => {
    if (!propWithMediaQueries) {
        return;
    }
    Object.entries(propWithMediaQueries).forEach(([query, property]) => {
        if (query.startsWith('@media ')) {
            if (!result[query]) {
                result[query] = {};
            }
            Object.assign(result[query], property);
        }
        else {
            result[query] = property;
        }
    });
};
//# sourceMappingURL=get-responsive-prop.js.map